/* eslint-disable no-nested-ternary */

import styled from 'styled-components';
import { Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import { Company } from 'Types/CompaniesTypes';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { useNavigate } from 'react-router-dom';
import { COMPANY_OVERVIEW_ROUTE, TOOLTIP_TOPACCOUNT } from 'Utils/Constants';
import { actions } from 'Slice/CompaniesSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { valueToObject } from 'Utils/UtilityFunctions';
import CompanyWidgetLarge from '../../common/components/CompanyWidgetLarge';
import {
  primaryFont, primaryHeadingColor, maxWidth, retina, maxTablet,
  wMLight,
} from '../../../Utils/utilsStyle';



const StyleWrapper = styled.div`
  .fancy-box {
    h4 {
      font-family: ${primaryFont};
      color: ${primaryHeadingColor};
      font-size: 18px;
      font-weight: ${wMLight};
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 16px;
      }
      @media all and (max-width: ${maxTablet}) {
        margin-bottom: 0px;
        font-size: 13px;
      }
    }
  }
  .company-row-grid {
    @media all and (max-width: ${maxTablet}) {
      padding-top: 8px;
    }
  }
  .company-row-grid {
    @media all and (max-width: ${maxTablet}) {
      padding-top: 8px;
    }
  }
  .company-row-grid {
    @media all and (max-width: ${maxTablet}) {
      padding-top: 8px;
    }
  }
`;

const Spacer = styled.div`
  margin-bottom: 130px;
  display: inline-block;
`;

type Props = {
  companies: Company[],
  loading: boolean
};

const TopCompany = function TopCompany(props: Props) {
  const { companies, loading } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const host = window.location.href;

  const handleCardClicked = ({ companyId, companyName }: Company) => {
    dispatch(actions.setNewsFlurry({}));
    navigate(`${COMPANY_OVERVIEW_ROUTE}${companyId}`);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('feedpage_topAccount_clicked', 0, {
        company_id: companyId,
        company_name: companyName,
        host,
      }),
    ));
  };

  const handleCardRightClicked = (companyId: number) => {
    window.open(`${COMPANY_OVERVIEW_ROUTE}${companyId}`, '_blank');
  };

  return (
    <StyleWrapper>
      <div className="fancy-box">
        {loading ? <SkeletonCustom height="20px" width="200px" margin="0px 0px 10px 0px" />
          : companies.length > 0 ? (
            <h4 className="d-flex align-items-center">
              Top Accounts
              <HeadingWithToolTip
                widthIcon="16px"
                heightIcon="18px"
                widthIconSm="12px"
                heightIconSm="18px"
                heightIconXSm="21px"
                toolTipText={TOOLTIP_TOPACCOUNT}
              />
            </h4>
          ) : <Spacer />}
        <div>
          <Row gutter={[12, 12]} className="wrap-slider hidden-scroll company-row-grid">
            {loading ? (
              <span className="resolution-fix for-comapny">
                <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
                <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
                <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
                <SkeletonCustom width="140px" height="90px" margin="0px 10px 10px 5px" />
              </span>
            )
              : companies.length > 0 && companies.map((item) => (
                <Col key={item.companyId} className="gutter-row d-flex justify-content-center">
                  <div
                    onClick={() => handleCardClicked(item)}
                    onKeyPress={() => handleCardClicked(item)}
                    tabIndex={0}
                    role="button"
                    className="c-pointer"
                    aria-label="View company"
                  >
                    
                      <CompanyWidgetLarge
                        key={item?.companyId}
                        width="155px"
                        height="92px"
                        widthSm="120px"
                        heightSm="80px"
                        heightXsm="50px"
                        widthXsm="82px"
                        widthXxsm="82px%"
                        heightXxsm="50px"
                        imagePosition="50% 10px"
                        imageSize="35% 60%"
                        persona={item.companyPersonality}
                        logo={item.companyLogo}
                        triggerColor={item.companyPulse}
                        title={item.companyName}
                        classWrapper="showSmallInXs"
                        showDrawerIcon={!!item.companyNotes}
                        showSapIcon={!!item.accountPlanAllowed}
                        id={item.companyId}
                        handleCardClicked={handleCardRightClicked}
                      />
                    
                  </div>
                </Col>
              ))}
          </Row>
        </div>
      </div>

    </StyleWrapper>
  );
};

export default TopCompany;
